import { setTerms } from './helpers';

export const setSaleTypes = setTerms('sost_type');
